import React from "react";
import { ReactComponent as CabinetSvg } from "../svg/cabinet.svg";

export default function CabinetIcon({ size = 64, color = "#32363F", ...props }) {
  return <CabinetSvg width={size} height={size} style={{ color }} {...props} />;
}
